import { Flex, FlexProps } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import { LinkButton } from "design_system/components/LinkButton";
import { OFText } from "design_system/components/OFText";
import { RegionType } from "graphql/generated";
import { colors } from "src/colors";
import { URL_AUTH } from "src/constants/url.constants";
import { FORM_TYPE } from "src/enums";
import { checkCountry } from "src/utils/checkCountry";

type Props = FlexProps & {
  onClick?(): void;
  theme?: "light" | "dark";
};
const HaveAccountFooter = ({ onClick, theme = "light", ...props }: Props) => {
  const router = useRouter();

  const { t } = useTranslation("register_form");

  const redirectToLogin = useCallback(() => {
    router.push(URL_AUTH(FORM_TYPE.LOGIN, router.asPath));
  }, [router]);

  return (
    <Flex alignItems="center" flexDir="row" {...props}>
      {checkCountry([RegionType.Jp]) ? (
        <OFText
          textStyle="body2"
          color={theme === "light" ? colors.black[900] : colors.white.off}
          display="flex"
          alignItems="center"
        >
          <Trans
            components={{
              login: (
                <LinkButton
                  onClick={onClick || redirectToLogin}
                  color={colors.primary}
                  cursor="pointer"
                  mx={1}
                />
              )
            }}
          >
            {t("register_form:jp_form_have_an_account_and_login_here_text")}
          </Trans>
        </OFText>
      ) : (
        <OFText textStyle="body2" color={theme === "light" ? colors.black[900] : colors.white.off}>
          {t("register_form:form-have-an-account-and-login-here-text")}
          <LinkButton
            label={t("register_form:login")}
            onClick={onClick || redirectToLogin}
            color={colors.primary}
            cursor="pointer"
            ml={2}
          />
        </OFText>
      )}
    </Flex>
  );
};

export default HaveAccountFooter;
